import { isEmail, isPhone, isHKPhone } from '@/utils/index'
import { api, emailNotice, getVerifyCode, mainDataQuery } from '@/utils/axios'
import el from 'element-ui/src/locale/lang/el'
import axios from 'axios' //这里引入axios  mian无需再引
import Vue from 'vue' //引入Vue
Vue.prototype.$ajax = axios //修改ajax原型指向为 axios
export default {
  name: 'bookingInfo',
  data() {
    return {
      phone: false,
      yzCode: false,
      ifEdit: false,
      dateValue: '',
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
      tableData: [],
      multipleSelection: [],
      pageCount: 1,
      pageNum: 0,
      areaBookinglist: [
        { id: 1, name: '佐敦旗舰店: 九龙弥敦道348号弥敦坊地库二层' },
        { id: 2, name: '佐敦分部: 九龙佐敦弥敦道238号9楼907-908室' },
        { id: 3, name: '旺角分部: 九龙弥敦道688号旺角中心第1期1303室' },
        { id: 4, name: '中环分部: 中环皇后大道中20号太平行6楼601室' },
        { id: 5, name: '铜锣湾分部: 香港铜锣湾恩平道44-48号恩平中心14楼' },
        { id: 6, name: '沙田分部: 新界沙田车站围1号连城广场2楼208-211号' },
        { id: 7, name: '元朗分部: 新界元朗水车馆街28号万金中心19-20号铺' },
        { id: 8, name: '上水分部: 新界上水龙琛路39号上水广场8楼811室' },
      ],
      areaValue: '',
      areaValueChange: false,
      dateEdit: '',
      dateEditChange: false,
      timeEdit: '',
      timeEditChange: false,
      editAreaID: 0,

      createdTimeW: 0,
      usernameW: 0,
      finishW: 0,
      phoneW: 0,
      user_idW: 0,
      packageW: 0,
      identW: 0,
      mainHeight:
        (window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight) - 60,

      pickerOptions: {
        disabledDate(time) {
          let _now = Date.now(),
            min = 3 * 24 * 60 * 60 * 1000,
            max = 14 * 24 * 60 * 60 * 1000,
            minDays = _now + min,
            maxDays = _now + max

          return time.getTime() < minDays || time.getTime() > maxDays
          //大于当前的禁止，小于7天前的禁止
        },
      },

      options: [
        {
          value: '0',
          label: '全部',
        },
        {
          value: '1',
          label: '已预约',
        },
        {
          value: '2',
          label: '已完成',
        },
        {
          value: '90',
          label: '已过期',
        },
      ],
      value: '0',
      http: api + 'v1/admin/exportExcel/',
      showDate: '',
      tipStatus: '',
      tipText: '',
      alertShow: false,

      downFile: false,

      emailNotice: false, // 设置系统通知
      emailNoticeVal: [{ value: '' }], //邮箱地址
      emailNoticeTel: '', //手机号
      oldEmailNoticeTel: '', //已有手机号,用来检查是否修改过手机号
      telArea: '852', //手机区号 默认香港852
      emailNoticeCode: '', //验证码
      codeSending: false, //是否正在发送验证码
      countDown: 60, //倒计时秒数
      selectList: [],
    }
  },

  mounted() {
    this.resizeChange()
    window.onresize = () => {
      return (() => {
        this.resizeChange()
      })()
    }
    let minDate = new Date()
    minDate.setDate(minDate.getDate() + 4)
    this.showDate = minDate
    mainDataQuery({
      act: 'appoint',
      startat: '',
      endat: '',
      // type: this.value,
      page: 1,
      pagesize: 10,
    }).then((res) => {
      if (res.code == 200) {
        const result = JSON.parse(window.atob(res.data))
        if (result.data != '') {
          this.pageCount = parseInt(result.pager.count)

          this.tableData = result.data

          this.downFile = true
        } else {
          this.alertShow = true
          this.tipStatus = '查询结果'
          this.tipText = '暂无数据'
          this.tableData = result.data

          this.downFile = false
        }
      }
    })
  },
  methods: {
    // 预约日期默认显示上一个月
    defaultDate() {
      let now = new Date(),
        y = now.getFullYear(),
        m = now.getMonth() + 1,
        d = now.getDate()
      return y + '/' + (m > 0 ? m - 1 : 12) + '/' + d
    },
    handleSelectionChange(val) {
      let list = []
      if (val && val.length > 0) {
        // 处理选中列表为选中Id列表
        val.map((item, index) => {
          list.push(item.id)
        })
      }
      this.selectList = list //选中Id列表
    },
    handleQuery() {},
    //设置邮箱通知
    setEmailNotice() {
      this.emailNotice = true

      //获取已有邮箱展示
      emailNotice({ act: 'query' }).then((res) => {
        if (res.code == 200) {
          this.emailNoticeTel = res.data.mobile
          this.oldEmailNoticeTel = res.data.mobile

          if (isPhone(this.emailNoticeTel)) {
            this.telArea = '86'
          } else {
            this.telArea = '852'
          }

          let emails = []
          for (var i = 0; i < res.data.email.length; i++) {
            emails.push({
              value: res.data.email[i],
            })
          }
          this.emailNoticeVal = emails
        } else {
          this.alertShow = true
          this.tipStatus = 'Err'
          this.tipText = res.msg
        }
      })
    },
    //邮箱验证
    emailVerify(email) {
      if (isEmail(email)) {
        return true
      } else {
        this.alertShow = true
        this.tipStatus = '邮箱格式错误'
        this.tipText = '请输入正确的邮箱'

        return false
      }
    },
    emailAllVerify() {
      for (var i = 0; i < this.emailNoticeVal.length; i++) {
        if (!this.emailVerify(this.emailNoticeVal[i].value)) {
          return false
        }
      }
      return true
    },
    //新增邮箱地址 最大10个
    addEmail() {
      if (this.emailNoticeVal.length < 10 && this.emailAllVerify()) {
        this.emailNoticeVal.push({
          value: '',
        })
      }
    },
    //删除邮箱地址
    removeEmail(index) {
      this.emailNoticeVal.splice(index, 1)
    },
    //获取验证码
    sendEmailCode() {
      if (this.emailNoticeTel != '' && this.phoneVerify()) {
        let data = {
          phone: this.emailNoticeTel,
          type: 5,
          loa: this.telArea,
        }
        getVerifyCode({
          data: window.btoa(JSON.stringify(data)),
        }).then((res) => {
          console.log(res)
          if (res.status == 1) {
            //成功发送验证码
            this.codeSending = true
            this.countDownStart()
          } else {
            this.alertShow = true
            this.tipStatus = '错误'
            this.tipText = res.msg
          }
        })
      } else {
        this.alertShow = true
        this.tipStatus = '手机号错误'
        this.tipText = '手机号格式不正确'
      }
    },
    //获取验证码倒计时
    countDownStart() {
      var timer = setInterval(() => {
        if (this.countDown > 0) {
          --this.countDown
        } else {
          clearInterval(timer)
          this.codeSending = false
          this.countDown = 60
        }
      }, 1000)
    },
    //保存信息
    saveInfo() {
      if (this.emailAllVerify() && this.phoneVerify()) {
        if (
          this.emailNoticeTel != this.oldEmailNoticeTel &&
          this.emailNoticeTel != '' &&
          this.emailNoticeCode == ''
        ) {
          this.alertShow = true
          this.tipStatus = '验证码错误'
          this.tipText = '验证码不能为空'
        } else if (this.emailNoticeTel == '' && this.emailNoticeCode != '') {
          this.alertShow = true
          this.tipStatus = '验证错误'
          this.tipText = '请输入验证码对应手机号'
        } else {
          let emailList = []
          for (var i = 0; i < this.emailNoticeVal.length; i++) {
            emailList.push(this.emailNoticeVal[i].value)
          }

          let data = {
            email: emailList,
            mobile: this.emailNoticeTel,
            loa: this.telArea,
            code: this.emailNoticeCode,
          }

          //手机号未变化
          if (data.mobile == this.oldEmailNoticeTel) {
            data.loa = ''
            data.code = ''
          }

          emailNotice(data).then((res) => {
            if (res.code == 200) {
              this.alertShow = true
              this.tipStatus = '保存成功'
              this.tipText = res.msg
              this.emailNotice = false
              this.emailNoticeCode = ''
            } else {
              this.alertShow = true
              this.tipStatus = '错误'
              this.tipText = res.msg
            }
          })
        }
      }
    },
    phoneVerify() {
      // 选填
      if (
        this.emailNoticeTel == '' ||
        (isPhone(this.emailNoticeTel) && this.telArea == '86') ||
        (isHKPhone(this.emailNoticeTel) && this.telArea == '852')
      ) {
        return true
      } else {
        this.alertShow = true
        this.tipStatus = '手机号错误'
        this.tipText = '手机号格式错误或区号不正确'
        return false
      }
    },
    onlyNumber(val) {
      if (/\D/g.test(val)) {
        this.emailNoticeTel = val.replace(/\D/g, '')
      }

      //自动给区号
      if (isHKPhone(this.emailNoticeTel)) {
        this.telArea = '852'
      } else if (isPhone(this.emailNoticeTel)) {
        this.telArea = '86'
      }
    },

    confirmDialog() {
      this.alertShow = false
    },
    closeDialog() {
      this.alertShow = false
      //把绑定的弹窗数组 设为false即可关闭弹窗
    },

    dateChange(time) {
      this.dateEditChange = true

      let week = new Date(time)
      if (week.getDay() == '0') {
        this.alertShow = true
        this.tipStatus = '查询失败'
        this.tipText = '请选择周日以外的日期'
      }
    },
    resizeChange() {
      let tableWidth = document.getElementsByClassName(
        'el-table__body-wrapper'
      )[0].offsetWidth
      this.createdTimeW = tableWidth * 0.1
      this.usernameW = tableWidth * 0.1
      this.finishW = tableWidth * 0.07
      this.phoneW = tableWidth * 0.11
      this.identW = tableWidth * 0.18
      this.user_idW = tableWidth * 0.1
      this.packageW = tableWidth * 0.09
    },
    // handleSelectionChange(val) {
    //     let selID = [];
    //     val.forEach((item, index) => {
    //         selID.push(item.id)
    //     })
    //     this.multipleSelection = selID;
    //     console.log('list', val);
    // },

    handleCurrentChange(val) {
      this.pageNum = val
      this.reportCommit(val)
    },
    reportCommit(val) {
      let data = {
        act: 'appoint',
        startat: this.dateValue ? this.dateValue[0] / 1000 : '',
        endat: this.dateValue ? this.dateValue[1] / 1000 + 86399 : '',
        // type: this.value,
        page: val,
        pagesize: 10,
      }
      mainDataQuery(data).then((res) => {
        if (res.code == 200) {
          const result = JSON.parse(window.atob(res.data))
          if (result.data != '') {
            this.pageCount = parseInt(result.pager.count)

            this.tableData = result.data

            this.downFile = true
          } else {
            this.alertShow = true
            this.tipStatus = '查询结果'
            this.tipText = '暂无数据'
            this.tableData = result.data

            this.downFile = false
          }
        }
      })
    },
    closeEdit() {
      this.ifEdit = false
      this.areaValue = ''
      this.dateEdit = ''
      this.timeEdit = ''
      this.editAreaID = 0
    },
    searchDateChange() {
      this.pageNum = 1
      // this.reportCommit(1);
    },
    getReport() {
      this.pageNum = 1
      this.reportCommit(1)
    },
    handleRet() {
      this.pageNum = 1
      this.dateValue = ''
      this.reportCommit(1)
    },
    selArea(id, type) {
      if (
        this.dateValue == '' ||
        this.dateValue[0] / 1000 == this.dateValue[1] / 1000
      ) {
        this.alertShow = true
        this.tipStatus = '修改失败'
        this.tipText = '请选择合适的起止日期'
      } else {
        let data = {
          act: 1,
          adid: type,
        }
        pushConfirmAxios(data, id).then((res) => {
          if (res.status == 1) {
            this.alertShow = true
            this.tipStatus = '修改成功'
            this.tipText = '已成功修改预约信息'
            this.reportCommit(this.pageNum)
          }
        })
      }
    },

    confirmEdit() {
      if (this.timeEdit == '' || this.dateEdit == '' || this.areaValue == '') {
        this.alertShow = true
        this.tipStatus = '提交失败'
        this.tipText = '请选择或填写相关信息'
      } else if (new Date(this.dateEdit).getDay() == '0') {
        this.alertShow = true
        this.tipStatus = '提交失败'
        this.tipText = '请选择周日以外的日期'
      } else {
        let Str = this.timeEdit,
          Temp = Str.split(':'),
          Seconds = 3600 * Number(Temp[0]) + 60 * Number(Temp[1])
        let data = {
          act: 2,
          adid: 1,
          atime: parseInt(this.dateEdit) / 1000 + Seconds,
          address_id: this.areaValue,
        }
        pushConfirmAxios(data, this.editAreaID).then((res) => {
          if (res.status == 1) {
            this.ifEdit = false
            this.areaValue = ''
            this.dateEdit = ''
            this.timeEdit = ''
            this.editAreaID = 0

            this.alertShow = true
            this.tipStatus = '修改成功'
            this.tipText = '已成功修改预约信息'
            this.reportCommit(this.pageNum)
          } else {
            this.alertShow = true
            this.tipStatus = '修改失败'
            this.tipText = res.msg
          }
        })
      }
    },
    editInfo(info) {
      this.editAreaID = info
      this.ifEdit = true

      this.areaValueChange = false //初始弹出默认未更改
      this.dateEditChange = false //初始弹出默认未更改
      this.timeEditChange = false //初始弹出默认未更改

      //修改默认值为之前用户填写值
      let itemInfo = this.tableData.filter((a) => a.id == info)[0],
        time = itemInfo.atime.split(' ')
      this.areaValue = this.areaBookinglist.filter(
        (n) => n.name.split('：')[0] == itemInfo.address
      )[0].id
      this.dateEdit = new Date(time[0].split('-').join('/')).getTime()
      this.timeEdit = time[1]
    },
    downExcel() {
      if (this.selectList.length <= 0) {
        this.alertShow = true
        this.tipStatus = '下载失败'
        this.tipText = '请选择要导出的数据'
      } else {
        this.$refs.down.click()
      }
      // if (this.dateValue == '' || this.dateValue[0] / 1000 == this.dateValue[1] / 1000 || this.value == '') {
      //     this.alertShow = true;
      //     this.tipStatus = "下载失败";
      //     this.tipText = "请选择合适的起止日期及信息";
      // } else {
      //     this.$refs.down.click();

      // }
    },
  },
}
